<template>
  <div>
    <v-dialog v-model="errorModal" width="500">
      <v-card>
        <v-card-title :class="`headline accent-3 ${color}`" primary-title>
          {{ this.color == "red" ? "Error" : "Success" }}
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="errorModal = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>Invitations</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          align="center"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">
              New Invitation
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">New Invitation</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-form ref="invitation_form" v-model="valid" lazy-validation>
                    <v-flex xs12>
                      <v-text-field
                        v-model="newInvitation.phone"
                        label="Phone No."
                        prefix="+88"
                        :rules="phoneRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="newInvitation.loan_product_id"
                        :items="
                          loanProducts.filter((product) => product.status)
                        "
                        item-text="product_title"
                        item-value="id"
                        label="Loan Product"
                        :rules="[(v) => !!v || 'Loan Product is required']"
                      ></v-select>
                    </v-flex>
                  </v-form>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                :loading="loading"
                :disabled="loading || !valid"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <UploadExcelDialog :apiUrl="apiUrl" @success="initialize" />
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :loading="dataLoading"
        :items="invitations"
        :rows-per-page-items="[10, 20, 50, 100, 500]"
        :pagination.sync="pagination"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="invitations">
          <td class="text-xs-center">{{ invitations.index + 1 }}</td>
          <td class="text-xs-center">{{ invitations.item.phone }}</td>
          <td class="text-xs-center">
            {{ loanProductName(invitations.item.loan_product_id) }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon small @click="deleteInvitation(invitations.item.id)">
              delete
            </v-icon>
          </td>
        </template>
        <template v-slot:no-data v-if="!dataLoading">
          <v-btn color="primary" @click="initialize">Restore</v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import {
    invitationUrl,
    loanProductsUrl,
    uploadInvitationsExcelUrl,
  } from "@/utils/variables";
  import { mapState, mapGetters } from "vuex";
  import UploadExcelDialog from "@/components/Dialogs/UploadExcelDialog";

  export default {
    components: {
      UploadExcelDialog,
    },
    data: () => ({
      dialog: false,
      loading: false,
      dataLoading: false,
      pagination: {
        rowsPerPage: 20,
      },
      search: "",
      apiUrl: uploadInvitationsExcelUrl,
      loanProducts: [],
      headers: [
        {
          text: "Serial No",
          align: "center",
          value: "serial_no",
          sortable: false,
        },
        { text: "Phone No.", align: "center", value: "phone", sortable: true },
        {
          text: "Loan Name",
          align: "center",
          value: "loan_product_id",
          sortable: true,
        },
        { text: "Actions", align: "center", value: "actions" },
      ],
      invitations: [],
      valid: true,
      phoneRules: [
        (v) => !!v || "Phone Number is required",
        (v) =>
          /^01{1}[3-9]{1}\d{8}$/.test(v) ||
          "Phone Number must be valid Bangladeshi mobile number",
      ],
      color: "",
      errorModal: false,
      errorMsg: "",
      newInvitation: {
        phone: "",
        loan_product_id: "",
      },
      defaultItem: {
        phone: "",
        loan_product_id: "",
      },
    }),

    computed: {
      ...mapState({
        token: (state) => state.auth.token,
      }),
      ...mapGetters(["isLoggedIn"]),
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.isLoggedIn ? this.initialize() : this.$router.push("signin");
    },

    methods: {
      loanProductName(loan_product_id) {
        const loanProduct = this.loanProducts.filter(
          (loanProduct) => loanProduct.id == loan_product_id
        );
        return loanProduct.length > 0
          ? loanProduct[0].product_title
          : "New Loan Product";
      },

      async initialize() {
        try {
          this.dataLoading = true;
          const { data } = await HTTP().get(loanProductsUrl);
          this.loanProducts = data.data;

          const response = await HTTP().get(invitationUrl);
          this.invitations = response.data.data;
          this.dataLoading = false;
        } catch (error) {
          this.color = "red";
          this.errorMsg = "Something went wrong";
          this.errorModal = true;
        }
      },

      async deleteInvitation(id) {
        // const index = this.indexData.users.indexOf(item);
        // var result =
        //   confirm("Are you sure you want to delete this item?") &&
        //   this.indexData.users.splice(index, 1);
        // if (result) {
        //   this.$store.dispatch("delete", [this.apiUrl, item.id]);
        //   this.initialize();
        // }
        try {
          const confirmation = confirm(
            "Are you sure you want to delete this invitation?"
          );
          if (confirmation) {
            const response = await HTTP().delete(`${invitationUrl}/${id}`);
            if (response.data && response.data.error == 0) {
              //   this.initialize();
              const deleteIndex = this.invitations.findIndex(
                (invitation) => invitation.id == id
              );
              this.invitations.splice(deleteIndex, 1);
              this.close();
              this.color = "green";
              this.errorMsg = "Deleted Successfully";
              this.errorModal = true;
            } else {
              this.color = "red";
              this.errorMsg = response.data.errorMsg;
              this.errorModal = true;
            }
          }
        } catch (error) {
          this.color = "red";
          this.errorMsg = "Something went wrong";
          this.errorModal = true;
        }
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.newInvitation = Object.assign({}, this.defaultItem);
        }, 300);
      },

      async save() {
        await this.$refs.invitation_form.validate();
        if (this.valid) {
          try {
            this.loading = true;
            const response = await HTTP().post(
              invitationUrl,
              this.newInvitation
            );
            if (response.data && response.data.error == 0) {
              //   this.initialize();
              this.invitations.push(response.data.data);
              this.close();
              this.color = "green";
              this.errorMsg = "Added Successfully";
              this.errorModal = true;
            } else {
              this.color = "red";
              this.errorMsg = response.data.errorMsg;
              this.errorModal = true;
            }

            this.loading = false;
          } catch (error) {
            this.color = "red";
            this.errorMsg = "Something went wrong";
            this.errorModal = true;
            this.loading = false;
          }
        }
      },
    },
  };
</script>
